export var reduxKey = '@@publicSession';
export var actionKey = '@@publicSession';
//# sourceMappingURL=constants.js.map